module.exports = __webpack_public_path__ + "static/img/4.423b417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/4.png
// module id = 1dHm
// module chunks = 0